import { createSlice } from "@reduxjs/toolkit";
import { getAuthProps, setAuthProps, signOut } from "../../lib/authenticationLibrary";
import { saveData } from '../../utils/LocalStorage/LocalStorageManager';

const authData = getAuthProps();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: (authData != null),
        user: (authData?.user), //Set user data from cookie.
        token: (authData?.token), //Set token data from cookie.
        authData,
        navigationMenuList: [],
        isLogedin: false,
        isResetPassword: false,
        isAuthLoading: true,
        organization: {}
    },
    reducers: {
        authentication: (state, action) => {

            const { securityPermissions, roles, ...newAuthProps } = action.payload;
            const { profilePicBase64, ...userWithoutProfilePic } = newAuthProps.user;

            const newAuthPropsWithoutProfilePic = { ...newAuthProps, user: userWithoutProfilePic, roles: roles };
            setAuthProps(newAuthPropsWithoutProfilePic);

            const {
                isAuthenticated,
                message,
                token,
                user,
                sessionTimeout,
                isResetPassword,
                organizationResponse,
                ...navigationMenuItems
            } = action.payload;

            state.navigationMenuList = navigationMenuItems.securityResponses;
            saveData('NavigationMenu', navigationMenuItems.securityResponses);

            state.user = user;
            state.roles = roles;
            state.isAuthLoading = false;

            saveData('SecurityPermission', securityPermissions);
            state.organization = organizationResponse;
            state.isLogedin = true;
            state.isResetPassword = action.payload.user.isResetPassword ? action.payload.user.isResetPassword : false
        },

        logout: (state) => {
            state.isLogedin = false;
            state.isAuthLoading = false;
            signOut();
        },

        setAuthLoading: (state, action) => {
            state.isAuthLoading = action.payload
        }
    },
});

export const { authentication, logout, setAuthLoading } = authSlice.actions;

export default authSlice.reducer;